import { render, staticRenderFns } from "./die-options.component.vue?vue&type=template&id=62894fd9&scoped=true&"
import script from "./die-options.component.ts?vue&type=script&lang=ts&"
export * from "./die-options.component.ts?vue&type=script&lang=ts&"
import style0 from "./die-options.component.scss?vue&type=style&index=0&id=62894fd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62894fd9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
